export class getgrid {
  agencyID: string | null;
  currentpageno: number=1;
  pageitem: number=10;
  searchText:string;
  requestStatusLid: string | null;
  OnboardStatusLid:string | null;
  orderColumn: string="Name";
  orderType: string="asc";
  type: string="string";
  field: string="name";
  operator: string="startswith";
  value: string="";
  matchCase: boolean=false;
  client:string;
}

export class employeeFilter {
  employeeType: string;
  employeeStatus: string;
}



export class getgridPurchase {
agencyID: string | null;
currentpageno: number=1;
pageitem: number=10;
requestStatusLid: string | null;
clientId :string | null;
orderColumn: string="PurchaseOrderNumber";
orderType: string="asc";
type: string="string";
field: string="purchaseOrderNumber";
operator: string="startswith";
value: string="";
matchCase: boolean=false;;
}

export class getgridTransaction {
agencyID: string | null;
currentpageno: number=1;
pageitem: number=10;
requestStatusLid: string | null;
clientId :string | null;
onboardingId :string | null;
orderColumn: string="transactionType";
orderType: string="asc";
type: string="string";
field: string="transactionType";
operator: string="startswith";
value: string="";
matchCase: boolean=false;
start: string | null;
end: string | null;
}





export class OfficeNotesBO {
documentLid: string;
officenotes: string;
agencyId: string;
}

